// extracted by mini-css-extract-plugin
export default {"left":"AppContainer_left__QnJj4"};